import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';

import {
  FETCH_VOCABULARY_RESULTS_REQUEST,
  FETCH_VOCABULARY_RESULTS_SUCCESS,
  FETCH_VOCABULARY_RESULTS_FAILURE,
} from './actions';
import Vocabulary from './model';

export default function vocabularyReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_VOCABULARY_RESULTS_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_VOCABULARY_RESULTS_SUCCESS:
      return ApiResponseHelper.create(action.payload.map((vocabulary) =>
        Vocabulary.create(vocabulary)));
    case FETCH_VOCABULARY_RESULTS_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/Vocabulary/reducer.js